<template>
  <a :href="url" class="link" :title="title" target="_blank">
    <span class="link-icon">
      <img :src="icon" :alt="title">
    </span>
    <div class="link-content">
      <span class="link-title">
        {{ title }}
      </span>
      <span class="link-controls" @click.stop.prevent="menuOpen = true" @mouseover.stop.prevent="menuOpen = true" @mouseleave.stop="menuOpen = false">
        <span v-if="menuOpen" class="link-controls-menu">
          <span @click.prevent="editLink(title, url, id)">{{$lang.messages.edit}}</span>
          <span @click.prevent="removeLink(id)">{{$lang.messages.remove}}</span>
        </span>
      </span>
    </div>
  </a>
</template>

<script>
const images = require.context('../assets/', false, /\.svg$/)
export default {
  name: 'Link',
  props: ['title', 'url', 'icon', 'id'],
  data: function () {
    return {
      menuOpen: false
    }
  },
  methods: {
    imgUrl: function (path) {
      return images('./' + path)
    },
    editLink (title, url, id) {
      const link = {
        title: title,
        url: url,
        id: id
      }
      this.$emit('editlink', link);
    },
    removeLink (link) {
      this.$emit('removelink', link);
    }
  }
}
</script>

<style lang="scss">
.link {
  background: #EFF0F7;
  border-radius: 60px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 6px 15px;

  &:hover {
    text-decoration: none;
  }

  &:focus {
    text-decoration: none;
  }

  &-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #27272C;
    width: calc(100% - 20px);
  }

  &-title {
    display: block;
    width: calc(100% - 25px);
    white-space: nowrap;
    overflow: hidden;
  }

  &-icon {
    margin-right: 10px;
    width: 16px;
    height: 16px;
    min-width: 16px;
  }

  &-controls {
    display: inline-block;
    padding: 5px;
    width: 24px;
    height: 24px;
    border-radius: 8px 8px 0px 0px;
    position: relative;
    
    &:before {
      content: '...';
      position: absolute;
      top: -11px;
      font-size: 26px;
    }
    
    &:hover {
      background: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }

    &-menu {
      background: #FFFFFF;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 8px 0px 8px 8px;
      position: absolute;
      z-index: 1;
      right: 0;
      top: 100%;
      padding: 8px 0;

      span {
        display: block;
        padding: 3px 10px;

        &:hover {
          background: #EFF0F7;
        }
      }
    }
  }
}
</style>
